import {
  SET_VIDEO_DEVICE_ID,
} from 'constants/ActionTypes';

const initialSettings = {
  videoDeviceId: '',
};

const scanner = (state = initialSettings, action) => {
  switch (action.type) {
    case SET_VIDEO_DEVICE_ID:
      return {
        ...state,
        videoDeviceId: action.payload
      };
    default:
      return state;
  }
};

export default scanner ;
